import { render, staticRenderFns } from "./BoardAlbum.vue?vue&type=template&id=c40b7626"
import script from "./BoardAlbum.ts?vue&type=script&lang=ts&external"
export * from "./BoardAlbum.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports